rass-qr {
  display: block;
  margin-bottom: 106px; // Must match the height of the #notification div
}

.qr-spinner {
  padding: 83px 0 83px 0;
}

.section-qr div.challenge-image {
  width: 224px;
  box-sizing: border-box;
}

.section-qr img.challenge-image-qr {
  display: block;
  width: 100%;
  border: 2px solid white;
}

@media (min-width: 576px) {
  img.paused {
    cursor: pointer;
  }
}

.cursor-pointer {
  cursor: pointer;
}
